<template>
  <div class="chat-box">
    <div v-if="tim.topMessage.text" class="top-item">
      <p class="message top-message">
        <img class="admin-tag" src="/dg3/static/assets/admin-chat-tag.png" />
        <span style="color: #1cff00">{{ room.officialNickname }}：</span>
        <span>{{ tim.topMessage.text }}</span>
      </p>
    </div>
    <div class="chat-list">
      <div v-for="message in chatMessages" :key="message.id" class="chat-item">
        <p v-if="message.type === 'join'" class="message join-message">
          <span style="margin-right: .2rem">{{ message.nickname }}</span>
          <span>来了！</span>
        </p>
        <p v-else-if="message.type === 'BUY'" class="message buy-message">
          <span style="margin-right: .2rem">{{ message.nickname }}</span>
          <span>正在购买</span>
        </p>
        <p v-else class="message">
          <span :style="'color: ' + message.nicknameColor">{{ message.nickname }}：</span>
          <span>{{ message.text }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import xss from 'xss'

export default {
  data () {
    return {
      chatMessages: [],
    }
  },

  computed: {
    ...mapState({
      tim: (state) => state.tim,
      room: (state) => state.room,
      user: (state) => state.user
    }),
  },

  watch: {
    'tim.latestMessage' (message) {
      if (this.chatMessages.length > 200) this.chatMessages.splice(126)

      this.chatMessages.unshift(this.formatChatMessage({
          id: message.sequence,
          from: message.from,
          nick: message.nick,
          content: message.payload.text
      }))
    },

    'tim.joinMessage' (message) {
      this.chatMessages.unshift({
        id: parseInt(Math.random() * 100000),
        nickname: message.nick,
        type: 'join'
      })
    },

    'tim.remindMessage' (message) {
      this.chatMessages.unshift({
        id: parseInt(Math.random() * 100000),
        nickname: message.content,
        type: message.tag
      })
    },

    'tim.deleteMessage' (message) {
      const index = this.chatMessages.findIndex(item => item.id === message.seq)
      this.chatMessages.splice(index, 1)
    },
  },

  methods: {
    setHistoryChatList (list) {
      const parseList = list.map(item => {
        const message = JSON.parse(item)

        return this.formatChatMessage({
          id: message.seq,
          from: message.account,
          nick: message.nick,
          content: message.content
        })
      })

      this.chatMessages = [...this.chatMessages, ...parseList]
    },

    formatChatMessage (message) {
      const isAdmin = message.from.indexOf('admin') === 0
      const colorArray = ['#F1FF16', '#16F1FF', '#F88433']
      message.nick = message.nick ? message.nick : ('万粉 GC' + message.id)

      return {
        id: message.id,
        from: isAdmin ? 'admin' : message.from,
        nickname: isAdmin ? this.room.officialNickname : message.nick,
        nicknameColor: colorArray[parseInt(Math.random() * colorArray.length)],
        text: xss(message.content, { whiteList: { img: ['src'] }}),
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-box {
  position: fixed;
  display: flex;
  flex-direction: column;
  width: 100%;
  top: calc(100vw * .5625 + 3.65rem);
  bottom: calc(1.16rem + constant(safe-area-inset-bottom));
  bottom: calc(1.16rem + env(safe-area-inset-bottom));
  background: linear-gradient(180deg, #F00939, #8308B7);
  // background: #320372 url('/dg3/static/assets/chats-bg.png') no-repeat;
  // background-size: 100%;
  .chat-list {
    flex: 1;
    position: relative;
    padding: 0 .24rem;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .chat-item {
      margin: .08rem 0;
      &:first-child {
        margin-top: 0;
      }
    }
  }
  .top-item {
    margin: .15rem .24rem .08rem;
  }
  .message {
    display: inline-block;
    padding: .05rem .2rem;
    max-width: 5.6rem;
    color: #FFF;
    background-color: rgba(0, 0, 0, .3);
    border-radius: .06rem;
    span {
      font-size: .28rem;
      vertical-align: middle;
    }
  }
  .message.top-message {
    background-color: #6702FE;
    .admin-tag {
      margin-right: .05rem;
      height: .26rem;
      vertical-align: middle;
    }
  }
  .message.join-message {
    color: #320372;
    background-color: #FBBD33;
  }
  .message.buy-message {
    color: #FFFFFF;
    background-color: #F74127;
  }
}
</style>